import React, { FC, useMemo } from "react"
import { Link } from "react-router-dom"

import { Alert, Anchor, List, Stack, Text } from "@mantine/core"
import { IconInfoCircle } from "@tabler/icons-react"

import { ModuleSettingsProps } from "../module-settings-card/ModuleSettingsProps"
import { useLanguage } from "../../../../contexts/language-context"

type SettingsOverwriteWarningProps = Omit<ModuleSettingsProps<string>, "organisation">

const SettingsOverwriteWarning: FC<SettingsOverwriteWarningProps> = ({ attrs, device, group }) => {
    const { L } = useLanguage()
    const nullishAttrs = useMemo(() => attrs && Object.values(attrs).filter(attr => attr.value === null), [attrs])

    if (nullishAttrs?.length)
        {
            return (
                        <Alert
                            variant="light"
                            title={L("%s apply", device ? L("Group settings") : L("Default settings"))}
                            icon={<IconInfoCircle size={20} />}
                        >
                            <Stack>
                                <Text>
                                    {device
                                        ? L(
                                              "This device is currently using settings from the %s. Apply specific settings to overwrite these.",
                                              <Anchor component={Link} to={`/groups/${group}`}>
                                                  {L("parent group")}
                                              </Anchor>,
                                          )
                                        : L(
                                              "This group is currently using default settings, because the group has no specific settings. Apply these settings below.",
                                          )}
                                </Text>
                                {/*<List size="xs">*/}
                                {/*    <Text>{L("The following settings are inherited:")}</Text>*/}
                                {/*    {nullishAttrs.map(attr => (*/}
                                {/*        // @ts-ignore*/}
                                {/*        <List.Item>{L(attr.name)}</List.Item>*/}
                                {/*    ))}*/}
                                {/*</List>*/}
                            </Stack>
                        </Alert>
                    )
        }
    else return null
}

export default SettingsOverwriteWarning
